import { FaArrowRight, FaGithub, FaLinkedin } from "react-icons/fa"; // Example with Font Awesome icon

export default function Contact() {
  return (
    <div
      id="contact"
      className="contactContainer h-[60vh] flex justify-center items-center flex-col px-5 text-center lg:text-start"
    >
      <h1 className="text-5xl font-bold">Contact Me</h1>
      <div className="mt-5">
        <span className="font-bold">Get in touch with me </span>
        <FaArrowRight className="w-8 h-5 inline" color="black" />
        <a
          className="font-bold hover:text-violet-700"
          href="mailto:girishkumarsp70@gmail.com"
        >
          girishkumarsp70@gmail.com
        </a>
      </div>
      <div className="mt-5 space-x-5">
        <a href="https://github.com/GirishKumarSp" target="_blank" rel="noreferrer">
          <FaGithub
            className="inline hover:text-violet-700 cursor-pointer"
            size={40}
          />
        </a>
        <a href="https://www.linkedin.com/in/girishkumarsp/" target="_blank" rel="noreferrer">
          <FaLinkedin
            className="inline hover:text-violet-700 cursor-pointer"
            size={40}
          />
        </a>
      </div>
    </div>
  );
}
